import * as $runtime from "../runtime.js";
import * as Restaumatic$dServices$dStorage from "../Restaumatic.Services.Storage/index.js";
import * as Specular$dCallback from "../Specular.Callback/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
const newPersistentRef = dictMonadFRP => {
  const Monad0 = dictMonadFRP.MonadCleanup1().Monad0();
  const Bind1 = Monad0.Bind1();
  const MonadEffect0 = dictMonadFRP.MonadEffect0();
  const newRef = Specular$dRef.new(MonadEffect0);
  const subscribeDyn_ = Specular$dFRP$dBase.subscribeDyn_(dictMonadFRP);
  const pure = Monad0.Applicative0().pure;
  return dictEncode => dictDecode => {
    const getJSONItem1 = Restaumatic$dServices$dStorage.getJSONItem()(dictDecode);
    return storage => key => defaultValue => Bind1.bind(MonadEffect0.liftEffect((() => {
      const $0 = getJSONItem1(storage)(key);
      return () => {
        const a$p = $0();
        return (() => {
          if (a$p.tag === "Nothing") { return defaultValue; }
          if (a$p.tag === "Just") { return a$p._1; }
          $runtime.fail();
        })();
      };
    })()))(initialValue => Bind1.bind(newRef(initialValue))(ref => Bind1.bind(subscribeDyn_(Restaumatic$dServices$dStorage.setJSONItem()(dictEncode)(storage)(key))(ref._1))(() => pure(ref))));
  };
};
const newPersistentFormFieldE = dictMonadFRP => {
  const Monad0 = dictMonadFRP.MonadCleanup1().Monad0();
  const bind = Monad0.Bind1().bind;
  const newPersistentRef1 = newPersistentRef(dictMonadFRP);
  const newCallback1 = Specular$dCallback.newCallback()(dictMonadFRP.MonadEffect0());
  const holdDyn = Specular$dFRP$dBase.foldDyn(dictMonadFRP)(x => v => x);
  const pure = Monad0.Applicative0().pure;
  return dictDecode => dictEncode => {
    const newPersistentRef2 = newPersistentRef1(dictEncode)(dictDecode);
    return storage => key => v => remoteState => initial => {
      const $0 = v.toFinal;
      return bind(newPersistentRef2(storage)(key)(initial))(ref => bind(newCallback1)(focusOutCallback => bind(holdDyn(false)(Specular$dFRP$dBase.leftmost([
        Specular$dFRP$dBase.functorEvent.map(v$1 => true)(focusOutCallback.event),
        Specular$dFRP$dBase.functorEvent.map(v$1 => true)(remoteState.submitOccured)
      ])))(isTouched => pure({editRef: ref, focusOutCallback: focusOutCallback.callback, finalValue: Specular$dFRP$dBase.functorDynamic.map($0)(ref._1), isTouched, remoteState}))));
    };
  };
};
const newPersistentFormField = dictMonadFRP => {
  const newPersistentFormFieldE1 = newPersistentFormFieldE(dictMonadFRP);
  return dictDecode => {
    const newPersistentFormFieldE2 = newPersistentFormFieldE1(dictDecode);
    return dictEncode => {
      const newPersistentFormFieldE3 = newPersistentFormFieldE2(dictEncode);
      return storage => key => v => remoteState => initial => newPersistentFormFieldE3(storage)(key)(v)(remoteState)(v.fromInitial(initial));
    };
  };
};
export {newPersistentFormField, newPersistentFormFieldE, newPersistentRef};
